module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-46-03-537.5446e792.mp4";